import { mapDTO } from '@twistezo/ts-dto-mapper'

import { TransferListItem } from 'components/Form/TransferList'
import { AdUnitForPageTransferListDTO } from './types'

export const adUnitForTransferListFromDTO = (
  from: AdUnitForPageTransferListDTO,
): TransferListItem =>
  mapDTO<AdUnitForPageTransferListDTO, TransferListItem>({ from }).transform(adUnitDTO => ({
    creamBackground: Boolean(adUnitDTO.ybAdUnitEnabled),
    label: adUnitDTO.path,
    value: adUnitDTO.id,
  }))
